<template>
  <modal :title="setModel.Name + ' - Match Currency'" @close="$emit('close')">
    <template #content>
      <loadArea v-if="currencies.length == 0"></loadArea>
      <Form
        method="dialog"
        v-slot="{ errors }"
        class="floating-labels p-1rem row"
        ref="form"
        v-if="currencies.length > 0"
      >
        <selectBox
          :title="'CurrencyCode'"
          v-model.number="model.CurrencyCode"
          :errors="errors"
          :rules="{ required: true }"
          :buttons="true"
          @keydown.enter="save"
        >
          <template #search>
            <input
              type="text"
              placeholder="Ara"
              class="form-control small"
              v-model="searchCountry"
            />
          </template>
          <template #input>
            <template v-for="item in currencies">
              <option
                :value="item.Code"
                :key="item.Code"
                v-if="
                  item.Name.toUpperCase().indexOf(searchCountry.toUpperCase()) >
                    -1
                "
                >{{ item.Name }}</option
              >
            </template>
          </template>
          <template #buttons>
            <button
              type="button"
              @click="addCurrenciesOpen = true"
              class="btn waves-effect waves-light btn-success"
            >
              <i class="fas fa-plus"></i>
            </button>
          </template>
        </selectBox>
      </Form>
    </template>
    <template v-if="currencies.length > 0" #foot>
      <Btn class="btn-success btn-md" @click="save" :process="process"
        >Match Currency</Btn
      >
    </template>
  </modal>
  <addCurrencies
    v-if="addCurrenciesOpen"
    @close="addCurrenciesOpen = false"
    @add="setCurrencies($event)"
  ></addCurrencies>
</template>

<script>
import selectBox from "@/components/formGroup/selectBox";
import addCurrencies from "@/views/currencies/upsert";
export default {
  props: {
    setModel: Object,
    currencies: Array,
  },
  components: { selectBox, addCurrencies },
  data() {
    return {
      searchCountry: "",
      addCurrenciesOpen: false,
      model: {
        Id: this.setModel.Id,
        CurrencyCode: this.setModel.Code1,
      },
      errs: {},
      process: false,
    };
  },
  created() {
    if (this.currencies.length == 0) {
      this.$appAxiosAdmin.get(`Currencies`).then((response) => {
        this.$emit("setCurrencies", response.data);
      });
    }
  },
  methods: {
    setCurrencies(item) {
      var data = this.currencies;
      data.unshift({
        Code: item.Code,
        Name: item.Name,
      });
      this.$emit("setCurrencies", data);
    },
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;
          this.$appAxiosAdmin
            .post(`SoftwareCurrencies/Match/`, this.model)
            .then(() => {
              this.$appAxiosAdmin
                .get(`SoftwareCurrencies/` + this.model.Id + `/1`)
                .then((response) => {
                  this.process = false;
                  this.$swal({
                    icon: "success",
                    title: "Success",
                    text: "Currency matched.",
                    timer: 2000,
                    confirmButtonText: "Okey",
                  });
                  this.$emit("update", response.data[0]);
                  this.$emit("close");
                });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>

<style></style>
